/* tslint:disable */
/* eslint-disable */
/**
 * MCP Manager API
 * API for managing Model Context Protocol (MCP) connections
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const ScopeType = {
    Organization: 'organization',
    Workspace: 'workspace',
    Portal: 'portal',
    User: 'user'
};
export function instanceOfScopeType(value) {
    for (const key in ScopeType) {
        if (Object.prototype.hasOwnProperty.call(ScopeType, key)) {
            if (ScopeType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function ScopeTypeFromJSON(json) {
    return ScopeTypeFromJSONTyped(json, false);
}
export function ScopeTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ScopeTypeToJSON(value) {
    return value;
}
export function ScopeTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
